
import { StoryboardFrame } from '@/features/storyboard/types/storyboard.types';
import { useAppMutation } from '@/shared/hooks/useAppMutation';
import { AppError } from '@/shared/types/AppError';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { storyboardRepository } from '../repository/StoryboardRepository';

const STORYBOARD_KEYS = {
    all: ['storyboards'] as const,
    byScene: (projectId: string, sceneId: string) => [...STORYBOARD_KEYS.all, projectId, sceneId] as const,
};

export const useStoryboardQuery = (projectId: string, sceneId: string | null) => {
    return useQuery({
        queryKey: STORYBOARD_KEYS.byScene(projectId, sceneId || ''),
        queryFn: async () => {
            if (!projectId || !sceneId) return [];
            const entity = await storyboardRepository.getBySceneId(projectId, sceneId);
            return entity ? entity.frames : [];
        },
        enabled: !!projectId && !!sceneId,
        staleTime: 1000 * 60 * 5, // 5 minutes
    });
};

export const useSaveStoryboardMutation = (projectId: string, sceneId: string) => {
    const queryClient = useQueryClient();

    return useAppMutation<void, AppError, StoryboardFrame[]>({
        mutationFn: (frames) => storyboardRepository.saveFrames(projectId, sceneId, frames),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: STORYBOARD_KEYS.byScene(projectId, sceneId) });
        }
    });
};
